const SaveIcon = ({
  style = { height: "2vh", width: "2vh" },
  color = "white",
}) => {
  return (
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="m32 36c-6.07 0-11 4.93-11 11s4.93 11 11 11 11-4.93 11-11-4.93-11-11-11zm6.64 12.77-6 5c-.19.15-.41.23-.64.23s-.46-.08-.64-.23l-6-5c-.32-.27-.44-.71-.3-1.11s.52-.66.94-.66h2v-4.92c0-1.15.93-2.08 2.08-2.08h3.83c1.15 0 2.08.93 2.08 2.08v4.92h2c.42 0 .8.26.94.66s.02.84-.3 1.11z"
        fill={color && color}
      />
      <path
        d="m59.73 14.19-11.12-11.87c-.19-.2-.45-.32-.73-.32h-35.91c-4.4 0-7.97 3.58-7.97 7.97v44.06c0 4.4 3.58 7.97 7.97 7.97h40.06c4.4 0 7.97-3.58 7.97-7.97v-39.16c0-.25-.1-.5-.27-.68zm-13.73-10.19v12.74c0 2.9-2.24 5.26-5 5.26h-18c-2.76 0-5-2.36-5-5.26v-12.74zm-34 56v-22.82c0-2.86 2.25-5.18 5.01-5.18h29.98c2.76 0 5.01 2.32 5.01 5.18v22.82z"
        fill={color && color}
      />
    </svg>
  );
};

export default SaveIcon;
